import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import { Paper, Typography, Box, Link, Container, GlobalStyles } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Loading from './Loading';

const HeroSlider = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const defaultImage = 'https://www.mrapi.mruns.com/wp-content/uploads/2020/01/83798790_2842918695768253_5984271632523329536_o-480x162.jpg';

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get('https://www.mrapi.mruns.com/wp-json/wp/v2/posts?per_page=5&_embed');
        
        const postsWithImages = response.data.map(post => {
          const imageUrl = post._embedded?.['wp:featuredmedia']?.[0]?.source_url || defaultImage;
          return { ...post, imageUrl };
        });

        setPosts(postsWithImages);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
  };

  if (loading) {
    return <Box sx={{ height: 'auto', minHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Loading /></Box>;
  }

  return (
    <Box>
      <GlobalStyles styles={(theme) => ({
        '.slick-dotted.slick-slider': {
          marginBottom: '30px !important',
        },
        '.slick-dots': {
          bottom: '-20px',
        },
        '.slick-dots li button:before': {
          fontSize: '10px',
          color: theme.palette.grey[400],
        },
        '.slick-dots li.slick-active button:before': {
          color: theme.palette.primary.main,
        },
      })} />
      <Slider {...settings}>
        {posts.map((post) => (
          <Link component={RouterLink} to={`/detail/${post.slug}`} key={post.id} sx={{ textDecoration: 'none' }}>
            <Paper
              sx={{
                position: 'relative',
                backgroundColor: 'grey.800',
                color: '#fff',
                py: { xs: 4, md: 10 }, 
                pb: { xs: 4, md: 10 },
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: `url(${post.imageUrl})`,
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  bottom: 0,
                  right: 0,
                  left: 0,
                  backgroundColor: 'rgba(0,0,0,0.4)',
                }}
              />
              <Container maxWidth="md">
                <Box sx={{ position: 'relative', textAlign: 'center' }}>
                  <Typography component="h1" variant={{ xs: 'h5', md: 'h3' }} color="inherit" gutterBottom sx={{ fontWeight: 'bold' }}>
                    <span dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                  </Typography>
                   <Typography variant={{ xs: 'body2', md: 'h5' }} color="inherit" paragraph>
                    <span dangerouslySetInnerHTML={{ __html: post.excerpt.rendered.substring(0, 120) + '...' }} />
                  </Typography>
                  <Typography variant="subtitle1" color="inherit">
                    Continue reading...
                  </Typography>
                </Box>
              </Container>
            </Paper>
          </Link>
        ))}
      </Slider>
    </Box>
  );
};

export default HeroSlider;
